(function (global, factory) {
  'use strict';
  var core = typeof module === 'object' && module.exports ? require('./events-manifest-core') : global.EventsManifestCore;
  var refreshApi = typeof module === 'object' && module.exports ? require('./events-manifest-refresh') : global.EventsManifestRefresh;
  var api = factory(core, refreshApi, global);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.ProductEventPanel = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function (core, refreshApi, runtime) {
  'use strict';

  var controllers = new WeakMap();
  var bootedDocuments = new WeakSet();

  function parse(node) {
    if (!node || typeof node.textContent !== 'string') throw new Error('missing JSON data');
    return JSON.parse(node.textContent);
  }
  function money(cents, locale, currency) {
    try { return new Intl.NumberFormat(locale || 'en-US', { style: 'currency', currency: currency }).format(cents / 100); }
    catch (_) { return currency + ' ' + (cents / 100).toFixed(2); }
  }
  function nodes(root) {
    var selectors = {
      heading: '[data-event-panel-heading]', discount: '[data-event-panel-discount]', offer: '[data-event-panel-offer]',
      regular: '[data-event-panel-regular]', savings: '[data-event-panel-savings]', copy: '[data-event-panel-copy]',
      terms: '[data-event-panel-terms]', days: '[data-days]', hours: '[data-hours]', minutes: '[data-minutes]', seconds: '[data-seconds]'
    };
    var result = {};
    Object.keys(selectors).forEach(function (key) { result[key] = root.querySelector(selectors[key]); });
    if (Object.keys(result).some(function (key) { return !result[key]; })) throw new Error('incomplete panel markup');
    return result;
  }
  function clockParts(distance) {
    var seconds = Math.max(0, Math.floor(distance / 1000));
    return {
      days: String(Math.floor(seconds / 86400)),
      hours: String(Math.floor(seconds % 86400 / 3600)).padStart(2, '0'),
      minutes: String(Math.floor(seconds % 3600 / 60)).padStart(2, '0'),
      seconds: String(seconds % 60).padStart(2, '0')
    };
  }
  function display(candidate, variant, root, now) {
    var event = candidate.event; var saved = candidate.saved;
    var offer = Math.max(0, variant.priceCents - saved);
    var fixed = event.discount.kind === 'fixed_cents';
    return {
      heading: event.presentation.title,
      discount: fixed ? money(event.discount.value, root.dataset.locale, root.dataset.currency) + ' off' : event.discount.value + '% off',
      offer: money(offer, root.dataset.locale, root.dataset.currency),
      regular: money(variant.priceCents, root.dataset.locale, root.dataset.currency),
      savings: 'Save ' + money(saved, root.dataset.locale, root.dataset.currency),
      copy: event.presentation.offerText,
      terms: event.presentation.termsText,
      eventId: event.eventId,
      discountId: event.nativeDiscountGid,
      clock: clockParts(event.endsAtExclusiveMs - now)
    };
  }
  function commit(root, targets, view) {
    targets.heading.textContent = view.heading;
    targets.discount.textContent = view.discount;
    targets.offer.textContent = view.offer;
    targets.regular.textContent = view.regular;
    targets.savings.textContent = view.savings;
    targets.copy.textContent = view.copy;
    targets.terms.textContent = view.terms;
    targets.days.textContent = view.clock.days;
    targets.hours.textContent = view.clock.hours;
    targets.minutes.textContent = view.clock.minutes;
    targets.seconds.textContent = view.clock.seconds;
    root.dataset.eventId = view.eventId;
    root.dataset.discountId = view.discountId;
    root.hidden = false;
  }
  function ownForm(root, document) {
    var id = root.dataset.productFormId;
    if (!id || !document || typeof document.getElementById !== 'function') return null;
    var form = document.getElementById(id);
    return form && typeof form.matches === 'function' && form.matches('form[action*="/cart/add"]') ? form : null;
  }
  function selectedVariantId(form) {
    if (!form || typeof form.querySelector !== 'function') return null;
    var field = form.querySelector('[name="id"]:checked') || form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');
    return field && field.value !== undefined ? String(field.value) : null;
  }

  function createController(root, env) {
    env = env || {};
    var document = env.document || runtime.document;
    var windowObject = env.window || runtime;
    var refreshFactory = env.refreshApi || refreshApi;
    var setIntervalFn = env.setInterval || runtime.setInterval;
    var clearIntervalFn = env.clearInterval || runtime.clearInterval;
    var setTimeoutFn = env.setTimeout || runtime.setTimeout;
    var now = env.now || Date.now;
    var alive = true; var timer = null; var refresher = null; var form = null; var section = null; var variants = new Map(); var events = []; var current = null; var releaseExpiresAtMs = 0;
    var targets;

    root.hidden = true;
    root.dataset.eventPanelState = 'initializing';

    function hide() {
      root.hidden = true;
      delete root.dataset.eventId;
      delete root.dataset.discountId;
    }
    function render() {
      if (!alive) return;
      try {
        hide();
        if (!current) return;
        var at = now();
        if (at >= releaseExpiresAtMs) return;
        var candidate = core.choose(events, {
          productId: root.dataset.productId,
          variantId: current.id,
          available: current.available,
          priceCents: current.priceCents
        }, at, root.dataset.currency, releaseExpiresAtMs);
        if (!candidate) return;
        var view = display(candidate, current, root, at);
        if (alive) commit(root, targets, view);
      } catch (_) { hide(); }
    }
    function select(id) {
      var text = id !== null && id !== undefined ? String(id) : '';
      var match = text.match(/^([1-9]\d*)$/) || text.match(/^gid:\/\/shopify\/ProductVariant\/([1-9]\d*)$/);
      current = match && variants.has(match[1]) ? variants.get(match[1]) : null;
      render();
    }
    function onFormChange() {
      setTimeoutFn(function () { if (alive) select(selectedVariantId(form)); }, 0);
    }
    function onVariantEvent(event) {
      var detail = event && event.detail;
      if (!detail || String(detail.sectionId || '') !== String(root.dataset.sectionId || '')) return;
      if (String(detail.productId || '') !== String(root.dataset.productId || '')) return;
      onFormChange();
    }
    function onResume() { if (refresher) refresher.refreshNow(); render(); }
    function destroy() {
      if (!alive) return;
      alive = false;
      if (timer !== null) clearIntervalFn(timer);
      if (refresher) refresher.destroy();
      if (form) form.removeEventListener('change', onFormChange);
      if (section) {
        section.removeEventListener('product:variant-change', onVariantEvent);
        section.removeEventListener('variant:change', onVariantEvent);
      }
      if (document && typeof document.removeEventListener === 'function') document.removeEventListener('visibilitychange', onResume);
      if (windowObject && typeof windowObject.removeEventListener === 'function') {
        windowObject.removeEventListener('focus', onResume); windowObject.removeEventListener('pageshow', onResume);
      }
      hide();
      root.dataset.eventPanelState = 'disposed';
      controllers.delete(root);
    }

    try {
      targets = nodes(root);
      var rawVariants = parse(root.querySelector('[data-event-panel-variants]'));
      if (!Array.isArray(rawVariants)) throw new Error('invalid variants');
      rawVariants.forEach(function (variant) {
        if (!variant || !/^(?:[1-9]\d*|gid:\/\/shopify\/ProductVariant\/[1-9]\d*)$/.test(String(variant.id || ''))) return;
        if (!Number.isInteger(variant.price) || variant.price < 0 || typeof variant.available !== 'boolean') return;
        variants.set(String(variant.id).match(/(\d+)$/)[1], { id: String(variant.id), priceCents: variant.price, available: variant.available });
      });
      form = ownForm(root, document);
      if (!form) throw new Error('missing associated product form');
      section = root.closest('[id^="shopify-section-"]');
      form.addEventListener('change', onFormChange);
      if (section) {
        section.addEventListener('product:variant-change', onVariantEvent);
        section.addEventListener('variant:change', onVariantEvent);
      }
      if (document && typeof document.addEventListener === 'function') document.addEventListener('visibilitychange', onResume);
      if (windowObject && typeof windowObject.addEventListener === 'function') {
        windowObject.addEventListener('focus', onResume); windowObject.addEventListener('pageshow', onResume);
      }
      select(selectedVariantId(form) || root.dataset.initialVariantId);
      if (env.disableRefresh === true) {
        var rawEnvelope = parse(root.querySelector('[data-events-manifest]'));
        var envelope = core.readEnvelope(rawEnvelope, { storeKey: root.dataset.storeKey, shopGid: root.dataset.shopGid }, now(), Number(root.dataset.maxManifestAgeMs));
        if (!envelope.ok) throw new Error(envelope.reason);
        events = envelope.events; releaseExpiresAtMs = envelope.releaseExpiresAtMs;
        root.dataset.eventPanelState = 'ready'; render(); timer = setIntervalFn(render, 1000);
      } else {
        if (!refreshFactory || typeof refreshFactory.create !== 'function' || !root.dataset.manifestUrl) throw new Error('manifest refresh unavailable');
        root.dataset.eventPanelState = 'refreshing';
        refresher = refreshFactory.create({
          url: root.dataset.manifestUrl,
          identity: { storeKey: root.dataset.storeKey, shopGid: root.dataset.shopGid },
          maxAgeMs: Number(root.dataset.maxManifestAgeMs),
          onAccept: function (envelope, trustedNow) {
            if (!alive) return;
            events = envelope.events; releaseExpiresAtMs = envelope.releaseExpiresAtMs; now = trustedNow;
            root.dataset.eventPanelState = 'ready'; render();
          },
          onFailure: render
        });
        timer = setIntervalFn(render, 1000);
      }
    } catch (_) {
      root.dataset.eventPanelState = 'failed';
      hide();
    }
    return { destroy: destroy, render: render, select: select, get state() { return root.dataset.eventPanelState; } };
  }

  function init(root, env) {
    var existing = controllers.get(root);
    if (existing) return existing;
    var controller = createController(root, env);
    controllers.set(root, controller);
    return controller;
  }
  function retry(root, env) {
    var existing = controllers.get(root);
    if (existing) existing.destroy();
    return init(root, env);
  }
  function initAll(scope, env) {
    var roots = (scope || runtime.document).querySelectorAll('[data-product-event-panel]');
    Array.prototype.forEach.call(roots, function (root) { init(root, env); });
  }
  function destroyAll(scope) {
    var roots = scope.querySelectorAll('[data-product-event-panel]');
    Array.prototype.forEach.call(roots, function (root) { var controller = controllers.get(root); if (controller) controller.destroy(); });
  }
  function boot(document) {
    if (!document || bootedDocuments.has(document)) return;
    bootedDocuments.add(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
    else initAll(document);
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target); });
  }

  if (typeof document !== 'undefined') boot(document);
  return { boot: boot, createController: createController, destroyAll: destroyAll, init: init, initAll: initAll, retry: retry };
}));
